export const idProfiles: any = {
	comercial: 1,
	tatico: 2,
	analitico: 3,
	estrategico: 4,
	operacional: 5,
};

export const areaIds: any = {
	Selecionartodos: 0,
	Business: 1,
	Finance: 2,
	Legal: 3,
	Operations: 4,
	OpsNonBillable: 5,
	People: 6,
	PeopleOperations: 7,
};

export const idsTrajectories: any = {
	financial: 1,
	people_management: 2,
	business: 3,
	technology: 4,
};


export const objFilterProfile: any = {
	'1': 'comercial',
	'2': 'tatico',
	'3': 'analitico',
	'4': 'estrategico',
	'5': 'operacional',
}
export const objFilterTrajectory: Record<string, string> = {
	'1': 'financial',
	'2': 'people_management',
	'3': 'business',
	'4': 'technology',
}
